<template>
  <div class="recommd-comp" v-loading="loading" :class="recommdTip ? 'active' : ''">
    <div style="width: 410px;border-left: 1px solid #D6D6D6;">
      <i class="el-icon-close" @click="$emit('recommdTipChange')"></i>
      <h4 style="text-align: center;margin-bottom: 12px;">我要推荐供应商</h4>
      <p class="recommd-desc">如果您要查找的零配件或供应商不存在，说明该供应商尚未入驻大工程师资源平台，烦请您将需求信息填写到下面的表格，我们负责和相关供应商联络入驻，以方便您的设计工作，第一个上传供应商信息的大工程师，事成之后有惊喜哦！</p>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
        size="small"
      >
        <el-form-item label="企业名称" prop="compName">
          <el-input v-model="ruleForm.compName" placeholder="请输入企业名称"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="userName">
          <el-input v-model="ruleForm.userName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="position">
          <el-input v-model="ruleForm.position" placeholder="请输入职位"></el-input>
        </el-form-item>
        <el-form-item label="企业位置" prop="addressObj">
          <el-cascader
            :props="cascaderProps"
            :options="options"
            size="mini"
            style="width: 100%"
            v-model="ruleForm.addressObj">
          </el-cascader>
        </el-form-item>
        <el-form-item label="主营产品" prop="products">
          <el-input v-model="ruleForm.products" placeholder="请输入主营产品"></el-input>
        </el-form-item>
      </el-form>
      <div class="submit-btn">
        <el-button type="primary" @click="_clueCreat" size="small">提交给平台</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {Message} from 'element-ui'
import zones_data from '@/components/region-picker';
import {Listener} from '@/libs'
import {ClueService} from '@/service'

export default {
  props: {
    recommdTip: { default: false }
  },
  data() {
    return {
      options: zones_data.zones_tree,
      loading: false,
      cascaderProps: {
        value: 'name',
        label: 'name',
      },
      ruleForm: {
        compName: '',
        userName: '',
        phone: '',
        position: '',
        products: '',
        addressObj: {},
      },
      rules: {
        compName: [{required: true, message: "请输入企业名称", trigger: "blur"}],
        userName: [{required: true, message: "请输入姓名", trigger: "blur"}],
        phone: [{required: true, message: "请输入电话", trigger: "blur"}],
      },
    }
  },
  mounted() {
    // 弹框列表出现后，点击其他任意位置，弹框缩回
    Listener.bodyEventDelegate([], 'recommd-comp', (obj) => {
      if (obj.type === 'out_click') {
        !obj.className.includes('att-rec-btn') && this.$emit('recommdTipChange', false)
      }
    });
  },
  methods: {
    _clueCreat() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true;
          const {compName, products, userName, phone, position, addressObj} = this.ruleForm;
          ClueService.clueCreate({
            compName: compName,
            province: addressObj[0],
            city: addressObj[1],
            district: addressObj[2],
            products,
            userName,
            phone,
            position,
          }).then(res => {
            if (res.code === 0) {
              Message.success("感谢您的推荐！");
              this.$refs.ruleForm.resetFields();
              this.$emit('recommdTipChange');
            }
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          })
        } else {
          return false;
        }
      });
    }
  },
}
</script>

<style lang="less" scoped>
  .recommd-desc{
    padding: 0px 22px;
    font-size: 13px;
    color: #606266;
    margin: 0px;
    text-indent: 2em;
    line-height: 22px;
  }
  .recommd-comp{
    width: 0;
    transition: all 0.3s;
    position: relative;
    overflow: hidden;
    /deep/ .el-icon-close{
      display: block;
      position: absolute;
      right: 0;
      top: 0;
      width: 36px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      font-size: 18px;
      cursor: pointer;
    }
    &>div{
      height: calc(100vh - 64px);
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
  .recommd-comp.active{
    width: 410px;
  }
  .demo-ruleForm{
    padding: 16px 36px 0 20px;
    /deep/ .el-input--mini .el-input__inner{
      height: 32px;
      line-height: 30px;
    }
  }
  .submit-btn{
    text-align: center;
  }
</style>
